export default {
  direction: 'rtl'
}
